import { render, staticRenderFns } from "./ChangeUserDataForm.vue?vue&type=template&id=3b92d6f4&scoped=true&"
import script from "./ChangeUserDataForm.vue?vue&type=script&lang=js&"
export * from "./ChangeUserDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserDataForm.vue?vue&type=style&index=0&id=3b92d6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b92d6f4",
  null
  
)

export default component.exports